export const LOAD_ORGANIZATION = 'organization/LOAD_ORGANIZATION';
export const RECEIVE_USER = 'organization/RECEIVE_USER';
export const EDIT_USER = 'organization/EDIT_USER';
export const RECEIVE_USERS = 'organization/RECEIVE_USERS';
export const REMOVE_USER = 'organization/REMOVE_USER';
